import { Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export function LanguageToggle({ className = '', compact = false }) {
  const { toggleLang } = useLanguage();
  return (
    <button
      type="button"
      data-testid="language-toggle-btn"
      onClick={toggleLang}
      aria-label="Switch language / 切换语言"
      className={`flex items-center gap-1 rounded-full border border-slate-200 bg-white px-3 py-1.5 font-mono text-xs text-slate-500 transition-colors hover:bg-slate-50 hover:text-slate-900 ${className}`}
    >
      {compact ? <Globe className="h-3.5 w-3.5" /> : '中文 / EN'}
    </button>
  );
}
